<div class="conditional-range-form conditional__full-width">
  <mat-form-field class="eiq-input__field" appearance="outline" [subscriptSizing]="'dynamic'">
    <mat-select [value]="fromValue$()" [placeholder]="'From'" (selectionChange)="onFromValueChange($event.value)">
      @for (option of fromOptions$(); track option.id) {
        <mat-option [value]="option">{{ option.value | toOrdinalNumber }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="eiq-input__field" appearance="outline" [subscriptSizing]="'dynamic'">
    <mat-select [value]="toValue$()" [placeholder]="'To'" (selectionChange)="onToValueChange($event.value)">
      @for (option of toOptions$(); track option.id) {
        <mat-option [value]="option">{{ option.value | toOrdinalNumber }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
